const state = {
  news: [],
};

const mutations = {
  SET_NEWS(state, news) {
    state.news = news;
  },
};

const getters = {
  getNews: (state) => {
    return state.news;
  },
};

export default {
  state,
  mutations,
  getters,
};
